import { ShippingMethod, Shippings } from '@app/pages/checkout-app/types';
import { capitalize } from '@utils/string-utils';

export const isLiveRateMethod = (category) =>
  [
    ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE,
    ShippingMethod.FIXED_LIVE_RATE,
    ShippingMethod.DOMESTIC_LIVE_RATE,
  ].includes(category);

export const getEstimatedTimeText = (estimatedTimeConversions): string[] => {
  const text = [];
  if (!estimatedTimeConversions) return text;
  else if (estimatedTimeConversions == 'live') {
    text.push('Est Delivery: dynamic by live rate');
  } else if (estimatedTimeConversions == 'pdqiq') {
    text.push('Est Delivery: dynamic by PDQ IQ');
  } else if (estimatedTimeConversions == 'manual') {
    text.push('Manual estimated time');
  }

  return text;
};

export const getDisplayEstimatedDeliveryText = (deliveryMethod: Shippings): string[] => {
  const fullText = [];
  if (deliveryMethod.displayEstDelivery || deliveryMethod.displayEstimatedDeliveryBusinessDays) {
    const { minDays, maxDays, minHours, maxHours, category } = deliveryMethod.shippingMethod;

    if (deliveryMethod.displayEstimatedDeliveryBusinessDays) fullText.push('show delivery time');
    if (deliveryMethod.displayEstDelivery) fullText.push('Show delivery date range');

    let type: string = 'days';
    let displayDeliveryPromiseText = '';
    let min = minDays ?? 0;
    let max = maxDays ?? 0;
    if (category === ShippingMethod.LOCAL) {
      type = 'hours';
      min = minHours ?? 0;
      max = maxHours ?? 0;
    }

    if (min === max || (min == 0 && max == 0)) {
      displayDeliveryPromiseText = `Est delivery: ${min} ${type}`;
    } else {
      displayDeliveryPromiseText = `${min} to ${max} ${type}`;
    }

    fullText.push(displayDeliveryPromiseText);
  }

  return fullText;
};

export const getDeliveryMethodsDaysNTimes = (deliveryMethod): string[] => {
  const text = [];

  if (deliveryMethod.deliveryDaysAllWeek) {
    text.push('Show 24/7');
    return text;
  }

  const deliveryDaysAndTimes = deliveryMethod.deliveryDaysAndTimes?.map((d: any) => {
    return {
      day: capitalize(d.day),
      enabled: d.enable,
      from: d.fromTime,
      to: d.toTime,
    };
  });

  for (const day of deliveryDaysAndTimes) {
    if (day.enabled) {
      text.push(`${day.day}, ${day.from} to ${day.to}`);
    }
  }

  return text;
};
